import { render, staticRenderFns } from "./talentManage.vue?vue&type=template&id=6c19525e&scoped=true"
import script from "./talentManage.vue?vue&type=script&lang=js"
export * from "./talentManage.vue?vue&type=script&lang=js"
import style0 from "./talentManage.vue?vue&type=style&index=0&id=6c19525e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c19525e",
  null
  
)

export default component.exports